import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { FormControl } from '@angular/forms';
import { TopicLevel2UIModel } from '@examdojo/category/v2';
import { ListViewGridMessages, provideSimpleListView } from '@examdojo/core/list-view';
import { ListViewComponent, provideAgGridService } from '@examdojo/ui/list-view';
import { AllTopicListViewAgGridService } from './topic-list-view-ag-grid.service';
import { TopicListViewService } from './topic-list-view.service';

@Component({
  selector: 'dojo-assessment-tl2-selector',
  imports: [ListViewComponent],
  templateUrl: './assessment-tl2-selector.component.html',
  styleUrl: './assessment-tl2-selector.component.scss',
  providers: [provideSimpleListView(TopicListViewService), provideAgGridService(AllTopicListViewAgGridService)],
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: { class: 'h-full block' },
})
export class AssessmentTl2SelectorComponent {
  @Input({ required: true }) formCtrl!: FormControl<Array<TopicLevel2UIModel['id']>>;

  readonly messages: ListViewGridMessages = {
    noDataBody: 'No topics have been found',
  };
}
